<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
    :fullscreen="$vuetify.breakpoint.xs"
    :transition="step == 2 && 'scroll-x-reverse-transition'"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="info"
        :class="{ 'mb-4' : $vuetify.breakpoint.xs }"
        v-bind="attrs"
        v-on="on"
        :disabled="disabledBtn"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t("affiliateCampaign.newCampaign") }}
      </v-btn>
    </template>
    <!-- card form create campaign -->
    <v-card v-if="step == 1">
      <v-toolbar>
        <v-toolbar-title
          class="title"
        >
          {{ $t('affiliateCampaign.newCampaign') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card-text class="pt-10 pb-0">
          <v-row no-gutters style="gap: 24px;">
            <!-- nome da campanha -->
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="campaignName"
                :label="$t('affiliateCampaign.name')"
                :rules="[rules.required]"
                outlined
                required
                counter="40"
                maxlength="40"
              ></v-text-field>
            </v-col>

            <!-- código da campanha -->
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="campaignCode"
                :label="$t('affiliateCampaign.campaignCode')"
                :rules="[
                  rules.required,
                  rules.noSpacesAreAllowed,
                  rules.noSpecialChar
                ]"
                counter="20"
                maxlength="20"
                outlined
                required
              ></v-text-field>
            </v-col>

            <!-- rede social -->
            <v-col
              cols="12"
            >
              <v-select
                v-model="selectedSocialMedia"
                :items="socialMediaList"
                :label="$t('affiliateCampaign.socialMedia')"
                :rules="[rules.required]"
                :menu-props="{ bottom: true, offsetY: true }"
                :class="{'pb-6' : selectedSocialMedia == 'Others'}"
                outlined
                hide-details="auto"
                required
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-4 pb-4 pt-8">
          <v-spacer />
          <v-btn
            class="info"
            @click="createCampaign()"
            :disabled="!valid || creatingCampaign"
            :loading="creatingCampaign"
          >
            {{$t("affiliateCampaign.createCampaign")}}!
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- card success feedback -->
    <v-card
      v-if="step == 2"
      width="600"
      min-height="344"
    >
      <div
        class="d-flex justify-end pa-4"
      >
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-title class="d-flex justify-center py-6">
        {{ $t("affiliateCampaign.campaignCreatedSuccessfully") }} &#9989;
      </v-card-title>
      <v-card-text class="pb-2">
        {{$t("affiliateCampaign.name")}}: {{ successCampaignName }}
      </v-card-text>
      <v-card-text>
        {{ $t("affiliateCampaign.socialMedia") }}: {{ successSocialMedia }}
      </v-card-text>
      <div class="d-flex flex-column pa-4" style="gap: 16px">
        <v-btn
          block
          color="primary"
          @click="routerPushCampaigns()"
        >
          {{ $t("affiliateCampaign.goToCampaigns") }}
        </v-btn>
        <v-btn
          block
          outlined
          color="primary"
          class="d-flex align-center"
          @click="$copy(campaignLink)"
        >
          <span class="white--text">
            {{ $t("affiliateCampaign.copyLink") }}
          </span>
          <v-icon
            right
            class="white--text"
          >mdi-content-copy</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/form-validate";
export default {
  props: {
    fetchAffiliateCampaigns: {
      type: Function,
    },
    disabledBtn: {
      type: Boolean
    }
  },
  data: (vm) => ({
    dialog: false,
    valid: false,
    creatingCampaign: false,
    step: 1,
    campaignName: "",
    campaignCode: "",
    campaignLink: "",
    selectedSocialMedia: "",
    // success
    successCampaignName: "",
    successSocialMedia: "",
    socialMediaList: [
      { text: "TikTok", value: "Tiktok" },
      { text: "Instagram", value: "Instagram" },
      { text: "Google", value: "Google" },
      { text: "YouTube", value: "Youtube" },
      { text: "WhatsApp", value: "Whatsapp" },
      { text: "Threads", value: "Threads" },
      { text: "Telegram", value: "Telegram" },
      { text: "Twitter", value: "Twitter" },
      { text: "Kwai", value: "Kwai" },
      { text: vm.$t("affiliateCampaign.others"), value: "Others" },
    ],
    rules: {
      required: validate.required,
      noSpacesAreAllowed: validate.noSpacesAreAllowed,
      passCaracter: validate.passCaracter,
      noSpecialChar: validate.noSpecialChar,
    },
  }),
  computed: {
    showSuccessDialog() {
      return this.$route.name != "AgentListCampaigns";
    }
  },
  methods: {
    async createCampaign() {
      const formIsValid = this.$refs.form.validate();
      if(formIsValid) {
        this.creatingCampaign = true;
        const body = {
          name: this.campaignName,
          channel: this.selectedSocialMedia,
          code: this.campaignCode,
        }
        await this.$axios
          .post("/agent/affiliateCampaign/createAfilliatesCampaings",this.$formdata(body))
          .then((resp) => {
            if (resp.status === 200) {
              // A Dialog de success (step == 2) é chamada quando o usuário cria a campanha
              // via componente, fora da view de listar campanhas
              if (this.showSuccessDialog) {
                this.successCampaignName = resp.data.dados.name;
                this.successSocialMedia = resp.data.dados.channel;
                this.campaignLink = resp.data.dados.link;
                this.step = 2;
              } else {
                this.$store.commit("setNotification", {
                  msg: resp.data.messages,
                  color: "success",
                });
                this.closeDialog(),
                this.fetchAffiliateCampaigns();
              }

              this.resetFormAndValidation();
            }

          })
          .catch(() => {
            this.creatingCampaign = false;
          })
          .finally(() => {
            this.creatingCampaign = false;
          });
      } else {
        return;
      }
    },

    routerPushCampaigns() {
      this.$router.push({ name: "AgentListCampaigns"})
    },

    closeDialog() {
      if (this.step == 1) {
        this.dialog = false;
        this.resetValidation();
      } else {
        this.dialog = false;
        this.step = 1;
      }
    },

    resetValidation() {
      this.$refs.form.resetValidation()
    },

    resetFormAndValidation() {
      this.$refs.form.reset();
    }
  }
}
</script>